import { render } from "./Router2.vue?vue&type=template&id=1b7fcbe7&scoped=true"
import script from "./Router2.vue?vue&type=script&lang=js"
export * from "./Router2.vue?vue&type=script&lang=js"

import exportComponent from "D:\\zhwf\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b7fcbe7"]])

export default __exports__